import { Canvas } from '../interface/Canvas.ts';

class GetCanvasResponse {
	canvasDetails: Canvas;

	constructor(canvasDetails: Canvas) {
		this.canvasDetails = canvasDetails;
	}

	formatCanvasDetailsData() {
		if (this.canvasDetails) {
			return {
				id: this.canvasDetails.canvas_id,
				imageUrl: this.canvasDetails.image_url,
				name: this.canvasDetails.name,
				status: this.canvasDetails.status,
				updatedAt: this.canvasDetails.updated_at,
				position: this.canvasDetails.position,
				scale: this.canvasDetails.scale,
				isPublic: this.canvasDetails.public,
			};
		}
		return {};
	}
}

export default GetCanvasResponse;
